const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB fillCT>path ` + (props.className || '')}
    >
      <path
        d="M4 8H6.4C6.61217 8 6.81566 7.91571 6.96569 7.76568C7.11571 7.61566 7.2 7.41217 7.2 7.2C7.2 6.98783 7.11571 6.78434 6.96569 6.63431C6.81566 6.48429 6.61217 6.4 6.4 6.4H4C3.78783 6.4 3.58434 6.48429 3.43431 6.63431C3.28429 6.78434 3.2 6.98783 3.2 7.2C3.2 7.41217 3.28429 7.61566 3.43431 7.76568C3.58434 7.91571 3.78783 8 4 8ZM13.6 0H2.4C1.76348 0 1.15303 0.252856 0.702944 0.702944C0.252856 1.15303 0 1.76348 0 2.4V9.6C0 10.2365 0.252856 10.847 0.702944 11.2971C1.15303 11.7471 1.76348 12 2.4 12H13.6C14.2365 12 14.847 11.7471 15.2971 11.2971C15.7471 10.847 16 10.2365 16 9.6V2.4C16 1.76348 15.7471 1.15303 15.2971 0.702944C14.847 0.252856 14.2365 0 13.6 0ZM14.4 9.6C14.4 9.81217 14.3157 10.0157 14.1657 10.1657C14.0157 10.3157 13.8122 10.4 13.6 10.4H2.4C2.18783 10.4 1.98434 10.3157 1.83431 10.1657C1.68429 10.0157 1.6 9.81217 1.6 9.6V4.8H14.4V9.6ZM14.4 3.2H1.6V2.4C1.6 2.18783 1.68429 1.98434 1.83431 1.83431C1.98434 1.68429 2.18783 1.6 2.4 1.6H13.6C13.8122 1.6 14.0157 1.68429 14.1657 1.83431C14.3157 1.98434 14.4 2.18783 14.4 2.4V3.2Z" fill="#717275"
      />
    </svg>
  );
};
